import purify from '../../../../node_modules/.pnpm/dompurify@2.4.3/node_modules/dompurify/dist/purify.js';

function sanitize(innerHtml, withTargetAttr) {
  if (withTargetAttr) addTargetBlankAttrToATagSecurely();
  return purify.sanitize(innerHtml);
}
function configuredSanitize(innerHtml, withTargetAttr, config) {
  var dompurifyConfig = {};
  if (config !== null && config !== void 0 && config.allowIframes) {
    dompurifyConfig.ADD_TAGS = ['iframe'];
  }
  if (withTargetAttr) addTargetBlankAttrToATagSecurely();
  return purify.sanitize(innerHtml, dompurifyConfig);
}
var addTargetBlankAttrToATagSecurely = function addTargetBlankAttrToATagSecurely() {
  // For temporarily saving original target value
  var TEMP_TARGET_ATTRIBUTE = 'data-target-temp';
  var TEMP_ONCLICK_ATTRIBUTE = 'data-onclick-temp';
  /**
   * Add DOMPurify hook to handling exceptional rules for certain HTML attributes.
   */
  purify.addHook('beforeSanitizeAttributes', function (node) {
    // Preserve default target attribute value
    if (node.tagName === 'A') {
      var targetValue = node.getAttribute('target');
      if (targetValue) {
        node.setAttribute(TEMP_TARGET_ATTRIBUTE, targetValue);
      } else {
        // set default value
        node.setAttribute('target', '_self');
      }
      var onclickValue = node.getAttribute('onclick');
      if (onclickValue) {
        node.setAttribute(TEMP_ONCLICK_ATTRIBUTE, onclickValue);
      }
    }
  });
  purify.addHook('afterSanitizeAttributes', function (node) {
    if (node.tagName === 'A') {
      if (node.hasAttribute(TEMP_TARGET_ATTRIBUTE)) {
        var value = node.getAttribute(TEMP_TARGET_ATTRIBUTE);
        if (value) node.setAttribute('target', value);
        node.removeAttribute(TEMP_TARGET_ATTRIBUTE);
        // Additionally set `rel="noopener"` to prevent another security issue.
        if (node.getAttribute('target') === '_blank') {
          node.setAttribute('rel', 'noopener');
        }
      }
      if (node.hasAttribute(TEMP_ONCLICK_ATTRIBUTE)) {
        var onclickValue = node.getAttribute(TEMP_ONCLICK_ATTRIBUTE);
        if (onclickValue) node.setAttribute('onclick', onclickValue);
        node.removeAttribute(TEMP_ONCLICK_ATTRIBUTE);
      }
    }
  });
};

export { configuredSanitize, sanitize as default };
//# sourceMappingURL=sanitize.js.map
